import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getClientAdvanced = api(({ clientId }) =>
    //export const getClientAdvanced = api(async function getClientAdvanced({ clientId } = {}) {
    query(
        gql`
            query getClientAdvanced($clientId: String) {
                getClientAdvanced(clientId: $clientId) {
                    id
                    crmCompanyId
                    excludeFromReporting
                }
            }
        `,
        { clientId },
        { returns: "getClientAdvanced" }
    )
)
